export default class KliraProduct {
    id = null;
    chargebeePlanId = null;
    chargebeeAddOnId = null;
    isBody = false;
    isNightCream = false;
    isDayScript = false;
    isSubscription = false;
    isCharge = false;
    isGiftCard = false;
    isVideoConsultation = false;
    isEachItemUnique = false;
    canBuyMultiple = false;
    imageUrl = null;
    name = null;
    price = null;
    journey_id = null;
    subscription_length = null;
}